import React, { useState, useCallback, useEffect } from "react";
import { get } from "../../../services/recebimentos";
import serviceCatalogos from "../../../services/catalogos";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
const uniq = (a) => [...new Set(a)];

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

const CatalogosEtiquetasModal = ({ campanha }) => {
  const [recebimentos, setRecebimentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [catalogosRows, setCatalogosRows] = useState([]);

  const loadData = useCallback(async () => {
    setLoading(true);
    const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=apelido&active=true`);
    const _recebimentosCampanha = get(`by-campanha/${campanha._id}`);
    const [catalogos, recebimentosCampanha] = await Promise.all([_catalogos, _recebimentosCampanha]);
    const catalogosRec = uniq(
      [...recebimentosCampanha]
        .filter((e) => {
          if (e.semMinimo || e.catalogoCodigo === "abelha") {
            return e;
          }
        })
        .map((e) => e.catalogoCodigo)
    );

    const catRows = catalogos.rows.filter((e) => catalogosRec.includes(e.codigo));
    for (const cat of catRows) {
      cat.logo = await getBase64FromUrl(cat.imagemLogo);
    }

    setCatalogosRows(catRows);
    setLoading(false);
    setRecebimentos(recebimentosCampanha);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const separaUsuariosEtiquetas = async (catalogoCodigo) => {
    let rows = uniq(
      [...recebimentos]
        .filter((e) => {
          if (catalogoCodigo === "abelha") {
            if (e.catalogoCodigo === catalogoCodigo) {
              return e;
            }
          } else {
            if (e.semMinimo && e.catalogoCodigo === catalogoCodigo) {
              return e;
            }
          }
        })
        .map((e) => {
          const catalogo = catalogosRows.find((e) => e.codigo === catalogoCodigo);
          const obj = { usuario: e.usuario.nome.toUpperCase(), itinerario:e.usuario.itinerario?.nome.toUpperCase()?? "-",catalogo: catalogo.logo };
					
          return obj;
        })
    );

		rows.sort((a,b)=>{
			if (a.itinerario === b.itinerario){
				return a.usuario < b.usuario ? -1 : 1
			} else {
				return a.itinerario < b.itinerario ? -1 : 1
			}
		});

    if (catalogoCodigo === "abelha"){
      // console.log('opa');
      const rowsCopy = [...rows];
      rows = [];
      for(const r of rowsCopy){
        if(!rows.find(e=>e.usuario===r.usuario)){
          rows.push(r);
        }
      }
    }

    var win = window.open("", "_blank");

		
		const cols = rows.map(test=>{
			return {
				table: {
					heights: [40, 40, 10],
					widths: [170],
					body: [
						[{image:test.catalogo, width:110, alignment:'center'}], 
						[{text:test.usuario, alignment:'center', bold:true, fontSize:12}], 
						[{text:test.itinerario,alignment:'center', fontSize:10}]
					],
				},
				layout: {
					hLineWidth: function (i, node) {
						return 0;
					},
					vLineWidth: function (i, node) {
						return 0;
					},
				},
			}
		});

		const linhas = [];
		let n=0;
		let linha = [];
		while(cols.length > 0){
			const col = cols.shift();
			if(n > 0 && n % 18 === 0){
				col.pageBreak = 'after';
			}
			linha.push(col);
			n++;
			if( n > 0 && n % 3 === 0){
				linhas.push(linha);
				linha=[];
			}
		}

		if(linha.length > 0){
			if (linha.length < 3){
				const diff = 3 - linha.length;
				for(let x=0; x < diff; x++){
					linha.push("");
				}
			}
			linhas.push(linha);
		} 
			
		
    const docDefinition = {
      pageSize: "A4",

      pageOrientation: "portrait",
			pageMargins: [ 10,10,10,10 ],
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              ...linhas
            ],
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return i === 0 || i === node.table.body.length ? 2 : 1;
            // },
            // vLineWidth: function (i, node) {
            //   return i === 0 || i === node.table.widths.length ? 2 : 1;
            // },
            hLineColor: function (i, node) {
              return "lightgray";
            },
            vLineColor: function (i, node) {
              return "lightgray";
            },
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 4, space: 4 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 4 } };
            },
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        subheader: {
          fontSize: 16,
          bold: true,

        },
        tableExample: {

        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        // alignment: 'justify'
      },
    };
    pdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs).open({}, win);
    
  };

  return (
    <div style={{ width: "700px", padding: 10 }} className="formModule">
      {loading && <>Carregando...</>}
      {!loading && (
        <>
          <div className="acoes" style={{flexWrap:'wrap'}}>
            {catalogosRows.map((item, index) => (
              <button key={index} onClick={() => separaUsuariosEtiquetas(item.codigo)} className="tornarRev" type="button">
                {item.apelido.toUpperCase()}
              </button>
            ))}
          </div>

        </>
      )}
    </div>
  );
};

export default CatalogosEtiquetasModal;
